import React from 'react';
import DriverManagement from './DriverManagement';
import { useTranslation } from 'react-i18next';

const Driver: React.FC = () => {
  const { t } = useTranslation('driver');
  return (
    <section className="px-4 py-3 space-y-5">
      <h6 className="font-bold text-title">{t('title.title')}</h6>
      <div>
        <DriverManagement />
      </div>
    </section>
  );
};
export default Driver;